const TYPE={
  login:'loginState',
  videoToken:'videoToken',
  videoContain:'videoContain',
  getSchoolId:'getSchoolId',
  izOutCamera:'izOutCamera',
  getSchoolName:'getSchoolName'
}

export default TYPE



// WEBPACK FOOTER //
// ./src/store/storeType.js